import { Injectable } from "@angular/core";
import { TranslationService } from "@app/services/translation.service";
import { VideoCoachingStatus } from "../enums/VideoCoachingStatus.enum";
import { VideoReviewStatus } from "../enums/VideoReviewStatus.enum";
import { VideoReviewSubStatus } from "../enums/VideoReviewSubStatus.enum";
import { IVideoEntry } from "../models/IVideoEntry";

@Injectable({ providedIn: 'root' })
export class VideoReviewStatusService {
    constructor(private readonly translationService: TranslationService) {}

    getVideoReviewStatusDisplayValue(video: IVideoEntry): string {
        return this.getReviewStatusDisplayValue(video.reviewStatus, video.reviewSubStatus, video.coachingStatus)
    }

    getReviewDisplayStatus(reviewStatus: VideoReviewStatus, reviewedSubStatus?: VideoReviewSubStatus): string {
        switch (reviewStatus) {
            case VideoReviewStatus.NeedsReview:
                return this.translationService.translateEnum(VideoReviewStatus, "VideoReviewStatus", reviewStatus);

            case VideoReviewStatus.Coached:
                return this.translationService.t("cameraService.Completed");

            case VideoReviewStatus.Reviewed:
                return reviewedSubStatus == VideoReviewSubStatus.NoActionRequired
                    ? this.translationService.t("cameraService.Completed")
                    : this.translationService.t("cameraService.InProgress");

            default:
                return this.translationService.t("cameraService.InProgress");
        }
    }

    getReviewSubDisplayStatus(reviewSubStatus: VideoReviewSubStatus, ignoreNone = false): string {
        if (reviewSubStatus === VideoReviewSubStatus.ActionRequired) {
            return this.translationService.t("cameraService.pending");
        } 
        
        if (reviewSubStatus === VideoReviewSubStatus.NoActionRequired) {
            return this.translationService.tEnum(VideoReviewSubStatus, "VideoReviewSubStatus", VideoReviewSubStatus.NoActionRequired);
        } 

        return ignoreNone
            ? ""
            : this.translationService.tEnum(VideoReviewSubStatus, "VideoReviewSubStatus", VideoReviewSubStatus.None);
        
    }

    getCoachingDisplayStatus(coachingStatus: VideoCoachingStatus, ignoreNone = false): string {
        switch (coachingStatus) {
            case VideoCoachingStatus.DriverTrained:
            case VideoCoachingStatus.Praise:
                return this.translationService.translateEnum(VideoCoachingStatus, "VideoCoachingStatus", coachingStatus);
            default:
                return ignoreNone
                    ? ""
                    : this.translationService.translateEnum(VideoCoachingStatus, "VideoCoachingStatus", VideoCoachingStatus.None);
        }
    }

    getReviewStatusDisplayValue(reviewStatus: VideoReviewStatus, reviewSubStatus: VideoReviewSubStatus, coachingStatus: VideoCoachingStatus): string {
        var reviewDisplayStatus = this.getReviewDisplayStatus(reviewStatus, reviewSubStatus);

        if (reviewStatus === VideoReviewStatus.NeedsReview) {
            return reviewDisplayStatus;
        }

        if (reviewStatus === VideoReviewStatus.Reviewed) {
            const reviewSubStatusString = this.getReviewSubDisplayStatus(Number(reviewSubStatus), true);

            if (reviewSubStatusString) {
                reviewDisplayStatus += ` (${reviewSubStatusString})`;
            }
        }

        if (reviewStatus === VideoReviewStatus.Coached) {
            const coachingStatusString = this.getCoachingDisplayStatus(Number(coachingStatus), true);
            
            if (coachingStatusString) {
                reviewDisplayStatus += ` (${coachingStatusString})`;
            }
        }
        return reviewDisplayStatus;
    }

}
